module.exports = __webpack_public_path__ + "static/media/steamfortress_03.89c2a233.jpg";